import styled, { keyframes } from 'styled-components';
import { UpDownAnimationI } from './interface';

const generateRandomAnimationDelayTime = (): string =>
  (Math.random() * (1.1 - 0.2) + 0.2).toFixed(1);

const upDownAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  
  100% {
    transform: translateY(8px);
  }
`;

export const UpDownAnimationContainer = styled.div<UpDownAnimationI>`
  animation: ${upDownAnimation}
    ${({ durationInSeconds }): string => (durationInSeconds ? `${durationInSeconds}s` : '2s')}
    infinite alternate ease-in-out;
  animation-delay: ${(): string => `${generateRandomAnimationDelayTime()}s`};
`;
